/* global google */
import { ref } from 'vue';

export function useGoogleSignIn({
  clientId,
  buttonRef,
  onError,
  buttonOptions = {},
}) {
  const isLoading = ref(false);
  const error = ref(null);

  function init(onCredential) {
    if (!clientId) return;
    const poll = () => {
      if (typeof google !== 'undefined' && google.accounts) {
        google.accounts.id.initialize({
          client_id: clientId,
          callback: (response) => handleCallback(response, onCredential),
        });
        google.accounts.id.renderButton(buttonRef.value, {
          theme: 'outline',
          size: 'large',
          width: 350,
          text: 'signin_with',
          ...buttonOptions,
        });
      } else {
        setTimeout(poll, 100);
      }
    };
    poll();
  }

  function handleCallback(response, onCredential) {
    error.value = null;
    isLoading.value = true;
    onCredential(response.credential).catch((err) => {
      isLoading.value = false;
      const message =
        err?.response?.data?.message ||
        'Google sign-in failed. Please try again.';
      error.value = message;
      if (onError) onError(message);
    });
  }

  return { isLoading, error, init };
}
